import React, { useEffect, useState, ReactNode, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import moIndustry from '../../store/industry';
import Empty from '@/component/empty';

interface IProps {}
interface IState {}

const PowerChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const powerRef = useRef<any>(null);
  let chart: any = null;
  const { powerList } = moIndustry;

  const getData = useMemo(() => {
    const Xdata: any = [];
    const data: any = [];
    powerList?.salary_change_trend?.forEach((res: any) => {
      Xdata.push(res.date);
      if (res.tag === 'predict') {
        data.push({
          value: res.change_rate,
          itemStyle: {
            color: Color.primaryColor(0.2),
            borderWidth: 1,
            borderType: 'dashed',
            borderColor: Color.primary,
          },
        });
      } else {
        data.push({
          value: res.change_rate,
        });
      }
    });
    return { Xdata, data };
  }, [powerList]);

  const render = () => {
    if (chart) chart.dispose();
    chart = init(powerRef.current);
    const option = {
      color: Color.primary,
      legend: {
        show: false,
      },
      grid: {
        left: 0,
        right: 0,
        bottom: 20,
        top: 20,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: getData.Xdata,
        axisLine: {
          show: true,
          lineStyle: { color: Color.ec },
        },
        splitNumber: 4,
        axisTick: { show: false },
        axisLabel: {
          show: true,
          fontSize: 12,
          color: Color.blackColor(0.5),
          fontFamily: 'Roboto',
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: Color.blackColor(0.08),
            width: 1,
            type: 'dashed',
          },
        },
      },
      yAxis: {
        type: 'value',
        axisTick: { show: false },
        axisLine: {
          show: false,
          lineStyle: { color: Color.ec },
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: Color.blackColor(0.08),
            width: 1,
            type: 'dashed',
          },
        },
        axisLabel: {
          color: Color.blackColor(0.85),
          fontFamily: 'Roboto',
          show: false,
        },
      },
      series: {
        name: '2021',
        type: 'bar',
        barWidth: 20,
        label: {
          show: true,
          fontFamily: 'Roboto',
          position: 'top',
          formatter: (parme: any) => {
            if (parme.value === 0) return 0;
            return `${round(parme.value * 100, 1)}%`;
          },
        },
        itemStyle: {
          borderRadius: [2, 2, 0, 0],
        },
        data: getData.data,
      },
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    if (!isEmpty(powerList?.salary_change_trend)){
      render();
    }
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [getData]);

  return (
    <section>
      {!isEmpty(powerList?.salary_change_trend) ? (
        <section className="power-chart" ref={powerRef} />
      ) : (
        <Empty height="auto" />
      )}
    </section>
  );
};

export default observer(PowerChart);
